__turbopack_context__.v({
  "noGalleryBackground": "AndroidNoGallery-module-scss-module__nEA5va__noGalleryBackground",
  "noGalleryContainer": "AndroidNoGallery-module-scss-module__nEA5va__noGalleryContainer",
  "noGalleryContent": "AndroidNoGallery-module-scss-module__nEA5va__noGalleryContent",
  "visionHeading": "AndroidNoGallery-module-scss-module__nEA5va__visionHeading",
});
